<template>
  <div id="app">
    <div style="margin-bottom: 100px; min-height: 100vh;">
    <div class="headers_nav">
      <div class="headers headers_box">
        <div class="headers_box_img">
          <img src="./assets/img/logo.png" alt="">
        </div>
        <div><span class="headers_txt">China Volleyball Association</span></div>
        <div class="headers_select">
          <!-- <el-select v-model="SeasonValue" placeholder="请选择" @change="ds">
            <el-option-group
              v-for="group in SeasonList"
              :key="group.SeasonID"
              :label="group.SeasonName">
                  <el-option
                    v-for="item in group.SportList"
                    :key="item.SportID"
                    :label="item.SportName"
                    :value="item.SportID"
                    >
                  </el-option>
            </el-option-group>
          </el-select> -->
          <!-- <div class="headers_div" @click="clickSelect">{{SeasonValue}}</div> -->
          <el-cascader
            v-model="SeasonValue"
            :options="SeasonList"
            ref="myCas"
            :collapse-tags="true"
            :props="{ expandTrigger: 'hover',
            children:'SportList',value:'SeasonID',
            label:'SeasonName',
            }"
            @expand-change="asd"
            @change="handleChange">
          
          </el-cascader>
        </div>
      </div>
    </div>
    <div class="headers_nav_txt">{{titleGameName}}</div>
    
    <div class="headers_nav">
      <div class="headers">
        <!-- <router-link to="/">首页</router-link>
        <router-link to="/about">比赛</router-link>
        <router-link to="/about">成绩公告</router-link>
        <router-link to="/about">数据统计</router-link> -->
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" :router="true">
          <el-menu-item index="1" @click="handleRouter('首页','','')">首页</el-menu-item>
          <!-- <el-menu-item index="/Home" route="/Home">首页</el-menu-item> -->
          <el-submenu index="2">
            <template slot="title">比赛</template>
            <el-menu-item v-for="(i,index) in PhaseArr" @click="handlePhase(i.PhaseID);handleRouter('比赛',i.PhaseID,i.PhaseName)" :key="i.PhaseID" :indexPath="i.PhaseID"  :index="'2-'+(index.toString())">{{i.PhaseName}}</el-menu-item>
            <!-- <el-menu-item v-for="(i) in PhaseArr" @click="handlePhase(i.PhaseID);handleRouter('比赛',i.PhaseID,i.PhaseName)" :key="i.PhaseID" :indexPath="i.PhaseID"  :index="'/GameMatch'">{{i.PhaseName}}</el-menu-item> -->
            <!-- <el-menu-item v-for="i in PhaseArr" :key="i.PhaseID" route="/GameMatch" index="/GameMatch">{{i.PhaseName}}</el-menu-item> -->
            <!-- <el-menu-item index="2-1" route="/GameMatch">选项1</el-menu-item>
            <el-menu-item index="2-2" route="/GameMatch">选项2</el-menu-item>
            <el-menu-item index="2-3" route="/GameMatch">选项3</el-menu-item> -->
            <!-- <el-submenu index="2-4">
              <template slot="title">选项4</template>
              <el-menu-item index="2-4-1" route="/Home">选项1</el-menu-item>
              <el-menu-item index="2-4-2" route="/Home">选项2</el-menu-item>
              <el-menu-item index="2-4-3" route="/Home">选项3</el-menu-item>
            </el-submenu> -->
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">成绩公告</template>
            <el-menu-item v-for="(i,index) in PhaseArr" @click="handlePhase(i.PhaseID);handleRouter('成绩',i.PhaseID,i.PhaseName)" :key="i.PhaseID" :index="'3-'+(index.toString())" >{{i.PhaseName}}</el-menu-item>
            <!-- <el-menu-item v-for="(i) in PhaseArr" @click="handlePhase(i.PhaseID);handleRouter('成绩',i.PhaseID,i.PhaseName)" :key="i.PhaseID" :index="'/PoolResult'" >{{i.PhaseName}}</el-menu-item> -->
            <!-- <el-menu-item v-for="i in PhaseArr" :key="i.PhaseID" index="/PoolResult" route="/PoolResult">{{i.PhaseName}}</el-menu-item> -->
            <!-- <el-menu-item index="3-2"  route="/PoolResult">选项2</el-menu-item>
            <el-menu-item index="3-3" route="/PoolResult">选项3</el-menu-item> -->
          </el-submenu>
          <el-menu-item index="4" @click="handleRouter('数据统计',0,'')">数据统计</el-menu-item>
          <el-menu-item index="5" @click="handleRouter('队伍组成','','')">队伍组成</el-menu-item>
          <!-- <el-menu-item index="/BestTeam" route="/BestTeam">数据统计</el-menu-item> -->
          <!-- <el-submenu index="4">
            <template slot="title">数据统计</template>
            <el-menu-item v-for="(i,index) in PhaseArr" @click="handlePhase(i.PhaseID);handleRouter('数据统计',i.PhaseID,i.PhaseName)" :key="i.PhaseID" :index="'4-'+(index.toString())" >{{i.PhaseName}}</el-menu-item> -->
            <!-- <el-menu-item v-for="(i) in PhaseArr" @click="handlePhase(i.PhaseID);handleRouter('数据统计',i.PhaseID,i.PhaseName)" :key="i.PhaseID" :index="'/BestTeam'" >{{i.PhaseName}}</el-menu-item> -->
            <!-- <el-menu-item index="4-1" route="/BestTeam">选项1</el-menu-item>
            <el-menu-item index="4-2" route="/BestTeam">选项2</el-menu-item>
            <el-menu-item index="4-3" route="/BestTeam">选项3</el-menu-item> -->
          <!-- </el-submenu> -->
        </el-menu>
        
      </div>
    </div>


    <router-view :sport="checkSportID" :event="EventID" :phase="PhaseID" />
    
    </div>
    <div class="beian"><p><a href="https://beian.miit.gov.cn/" target="_blank">京ICP备 2023012929号-1</a></p></div>
    <!-- <div class="footer_bg">
      
      <el-footer>
        <img class="footer_img" src="./assets/img/footer.png" alt="">
      </el-footer>
    </div> -->
    <el-backtop :bottom="100">
      <div
        style="{
          height: 100%;
          width: 100%;
          box-shadow: 0 0 6px rgba(0,0,0, .12);
          text-align: center;
          line-height: 40px;
          color: #1989fa;
          border-radius:50%;
        }"
      >
      <i class="el-icon-caret-top"></i>
      </div>
    </el-backtop>
    
  </div>
</template>

<script>
  import http from '@/assets/js/http.js';
  export default {
    data() {
      return {
        activeIndex: '1',
        options: [{
          label: '黄金糕',
          value: '选项1',
          children: [{
            value: '1',
            label: '上海'
          }, {
            value: '2',
            label: '北京'
          }]
        }, {
          label: '双皮奶',
          value: '选项2',
          children: [{
            value: '3',
            label: '上海'
          }, {
            value: '4',
            label: '北京'
          }]
          
        }, {
          value: '选项3',
          label: '蚵仔煎',
          children: []
        }, {
          label: '龙须面',
          value: '选项4',
          children: [{
            value: '5',
            label: '上海'
          }, {
            value: '6',
            label: '北京'
          }]
        }, {
          label: '北京烤鸭',
          value: '选项5',
          children: [{
            value: '7',
            label: '上海'
          }, {
            value: '8',
            label: '北京'
          }]
        }],
        SeasonValue: '',
        SeasonList:[],
        titleGameName: '',
        checkSportID: 0,
        PhaseArr: [],
        PhaseID: 0,
        EventID: 0,
        parent:0,
        season:0,
      };
    },
    watch: {
      // 监测路由变化,只要变化了就调用获取路由参数方法将数据存储本组件
      // $route: "handleChange",
      // checkSportID(newVal,oldVal){
      //   console.log('这是新值:',newVal)
      //   console.log('这是laozhi:',oldVal)
      // },
      $route: { // 亲测有效,我是用来监听query参数变化
          handler(newVal,oldVal) {
              // this.id = this.$route.query.id;
              // this.getDetail();
              // console.log('这是新值:',newVal)
              // console.log('这是laozhi:',oldVal)
              //深度监听，同时也可监听到param参数变化
              let params = JSON.parse(this.$UrlEncode.decode(this.$route.query.key))
              // console.log(params)
        },
        deep: true,
      }
    },
    
    created(){
      // this.$cookie.config('2h');
      http.GetSeasonList().then(res=>{////获取赛季接口
            console.log(res)
            if(res.Status == 1){
              this.SeasonList = res.DataResult;
              for(let i = 0;i < this.SeasonList.length;i++){
                if(this.SeasonList[i].SportList.length > 0){
                  for(let j =0;j < this.SeasonList[i].SportList.length;j++){
                    let items = this.SeasonList[i].SportList[j];
                    items['SeasonName'] = items.SportName;
                    items['SeasonID'] = items.SportID;
                    items['parentName'] = this.SeasonList[i].SeasonName;
                    items['parentID'] = this.SeasonList[i].SeasonID;
                    if(items.Active == 1){
                      this.SeasonValue = [this.SeasonList[i].SeasonID,items.SeasonID];
                      this.titleGameName = items.SportName;
                      this.checkSportID = items.SeasonID;
                      this.EventID = items.EventID;
                      this.parent = this.SeasonList[i].SeasonID;
                      this.season = items.SeasonID;
                      // this.$cookie.set('SportID',this.checkSportID,'2h');
                      // this.$cookie.set('EventID',this.EventID,'2h');
                      // this.$cookie.set('parentID',this.SeasonList[i].SeasonID);
                      // this.$cookie.set('SeasonID',items.SeasonID);
                    }
                    
                  }
                }else{
                  this.SeasonList[i]['disabled'] = true;
                }
              }
              this.$cookie.set('SportID',this.checkSportID,'2h');
              // this.$cookie.set('EventID',this.EventID);
              

              if(this.$route.query.key != undefined){
                let params = JSON.parse(this.$UrlEncode.decode(this.$route.query.key))
                this.my_data = params;
                // console.log(params)
                if(this.$cookie.get('parentID') != null){
                  let  parent = this.$cookie.get('parentID');
                  let  Seasons = this.$cookie.get('SeasonID');
                  this.SeasonValue = [Number(parent),Number(Seasons)]
                  this.EventID = this.$cookie.get('EventID');
                  this.titleGameName =this.$cookie.get('titleGameName');
                }else{
                  this.SeasonValue = [params.parent,params.season];
                  this.EventID = params.EventID;
                  this.titleGameName = params.sportName;
                }
                
                // this.SeasonValue = [params.parent,params.season];
                
              }else{
                if(this.$cookie.get('EventID') != null && this.$cookie.get('parentID')!= null){
                  let  parent = this.$cookie.get('parentID');
                  let  Seasons = this.$cookie.get('SeasonID');
                  this.EventID = this.$cookie.get('EventID');
                  this.titleGameName =this.$cookie.get('titleGameName');
                  this.SeasonValue = [Number(parent),Number(Seasons)]
                  // console.log('12323333')
                }else{
                  // this.EventID = this.$cookie.get('EventID');
                  // console.log('12323')
                  // console.log(this.EventID)
                  this.$cookie.set('EventID',this.EventID,'2h');
                }
              }
              this.GetPhaseList(this.EventID)//获取阶段列表接口
              // console.log(this.SeasonValue)
            }else{
              this.SeasonList = [];
              // this.$message.error('获取赛事失败！');
            }
        })
        // let cc = {
          
        // }
    },
    mounted() {
        console.log(http2)
        // setTimeout(()=>{
        //   this.GetPhaseList(this.checkSportID)//获取阶段列表接口
        // },100)

        let getActiveIndex = this.$cookie.get('activeIndex');
        console.log(getActiveIndex)

        if(getActiveIndex !=null){
          if(this.$route.name == 'Home'){
            this.activeIndex = '1'
          }else{
            this.activeIndex = getActiveIndex;
          }
          
        }
        //  if(this.$route.query.key != undefined){
        //     let params = JSON.parse(this.$UrlEncode.decode(this.$route.query.key))
        //     this.my_data = params;
        //     console.log(params)
        //     let  parent = this.$cookie.get('parentID');
        //     let  Season = this.$cookie.get('SeasonID');

        //     this.SeasonValue = [parent,Season];
        //     // this.GetEventStatHome(this.my_data.EventID);//获取首页9大统计数据接口
        //   }else{
            
        //   }

    },
    methods: {
      handleSelect(key, keyPath) {//组件自带的select时间，获取不到val
        // console.log(key, keyPath);
        this.activeIndex = key;
        this.$cookie.set('activeIndex',key,'2h')
        // console.log(this.aaa)

      },
      handleRouter(txt,PhaseID,phaseName){//点击导航的按钮
        // console.log(txt)
        let SportID = this.checkSportID;
        let EventID = this.EventID;
        if(txt == '首页'){
          this.$router.push({
            path: "/Home",
            query:{
              key:this.$UrlEncode.encode(JSON.stringify({
                sportID: SportID,
                phaseID: PhaseID,
                phaseName: phaseName,
                sportName: this.titleGameName,
                EventID: EventID,
                activeIndex: this.activeIndex,
                parent: this.parent,
                season: this.season,
              }))
            }
          })
        }else if(txt == '比赛'){
          this.$router.push({
            path: "/GameMatch",
            query:{
              key:this.$UrlEncode.encode(JSON.stringify({
                sportID: SportID,
                phaseID: PhaseID,
                phaseName: phaseName,
                sportName: this.titleGameName,
                EventID: EventID,
                activeIndex: this.activeIndex,
                parent: this.parent,
                season: this.season,
              }))
            }
          })
        }else if(txt == '成绩'){
          this.$router.push({
            path: "/PoolResult",
            query:{
              key:this.$UrlEncode.encode(JSON.stringify({
                sportID: SportID,
                phaseID: PhaseID,
                phaseName: phaseName,
                sportName: this.titleGameName,
                EventID: EventID,
                activeIndex: this.activeIndex,
                parent: this.parent,
                season: this.season,
              }))
            }
          })
        }else if(txt == '数据统计'){
          
          this.$router.push({
            path: "/BestTeam",
            query:{
              key:this.$UrlEncode.encode(JSON.stringify({
                sportID: SportID,
                phaseID: PhaseID,
                phaseName: phaseName,
                sportName: this.titleGameName,
                EventID: EventID,
                activeIndex: this.activeIndex,
                parent: this.parent,
                season: this.season,
              }))
            }
          })
        }else if(txt == '队伍组成'){
          
          this.$router.push({
            path: "/TeamConstitute",
            query:{
              key:this.$UrlEncode.encode(JSON.stringify({
                sportID: SportID,
                phaseID: PhaseID,
                phaseName: phaseName,
                sportName: this.titleGameName,
                EventID: EventID,
                activeIndex: this.activeIndex,
                parent: this.parent,
                season: this.season,
              }))
            }
          })
        }



      },
      handlePhase(val){//点击导航的下拉按钮
        // console.log(val)
        this.$cookie.set('PhaseID',val,'2h')
        sessionStorage.setItem('PhaseID',val)
        this.PhaseID = val;

        // this.$router.push({
        //   path: "/GameMatch",
        //   query:{
        //     key:this.$UrlEncode.encode(JSON.stringify({
        //       sportID:'4',
        //       phaseID: '3',
        //       phaseName: 'asd',
        //       sportName: '这是不是',
        //     }))
        //   }
        // });        
      },
      ds(val){
        console.log(val)
        console.log(this.SeasonValue)
      },
      getCheckedNodes(leafOnly){
        console.log(leafOnly)
      },
      asd(value){
        console.log(value);
      },
      handleChange(value) {//点击最上面的赛季选择下拉框
        console.log(value);
        // console.log(this.SeasonValue);
        
        let checkedNodes = this.$refs['myCas'].getCheckedNodes()
        console.log(checkedNodes[0].data)
        // console.log(this.$refs['myCas'].getCheckedNodes()[0].pathLabels)
        // this.SeasonValue = checkedNodes[0].data.parentName;
        this.titleGameName = checkedNodes[0].data.SportName;
        this.EventID = checkedNodes[0].data.EventID;
        this.checkSportID = checkedNodes[0].data.SportID;
        this.parent = checkedNodes[0].data.parentID;
        this.season = checkedNodes[0].data.SeasonID;
        // this.GetEventStatHome();//获取首页9大统计数据接口
        this.$route.query.SportID = this.checkSportID,
        // console.log(this.$route)
        this.GetPhaseList(this.EventID)//获取阶段列表接口
        this.$cookie.set('SportID',this.checkSportID,'2h');
        this.$cookie.set('EventID',this.EventID,'2h'); 

        this.$cookie.set('parentID',checkedNodes[0].data.parentID,'2h');
        this.$cookie.set('SeasonID',checkedNodes[0].data.SeasonID,'2h');
        this.$cookie.set('titleGameName',checkedNodes[0].data.SportName,'2h');
        

        if(this.$route.name != 'Home'){
          this.activeIndex = '1';
          this.$cookie.set('activeIndex',1,'2h')
            this.$router.push({
              path: "/Home",
              query:{
                key:this.$UrlEncode.encode(JSON.stringify({
                  sportID: this.checkSportID,
                  phaseID: this.PhaseID,
                  phaseName: '',
                  sportName: this.titleGameName,
                  EventID: this.EventID,
                  activeIndex: this.activeIndex,
                }))
              }
            })
        }
        
      },
      clickSelect(){
        
      },
      GetPhaseList(ID){//获取阶段列表接口
        http.GetPhaseList(ID).then(res=>{////获取阶段列表接口
          // console.log(res)
          if(res.Status == 1){
            this.PhaseArr = res.DataResult;
          }else{
            this.PhaseArr = [];
            // this.$message.error('获取赛事失败！');
          }
        })
      }
      
    }
  }
</script>

<style>
html,body{
  /* height: 100%; */
  /* overflow-y: scroll; */
  overflow: auto;
 
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
}
.headers{
  width: 1250px;
  margin: 0 auto;
}
.headers_nav{
  background: white;
}
.headers_box{
  display: flex;
  align-items: center;
}
.headers_txt{
  color: #409EFF;
  font-weight: bold;
  font-size: 24px;
  margin-left: 10px;
}
.headers_select{
  margin-left: 20px;
  position: relative;
}
.headers_nav_txt{
  background: #409EFF;
  font-size: 24px;
  color: white;
  width: 100%;
  height: 36px;
  line-height: 36px;
}
.headers_div{
  position: absolute;
  width: 100%;
  line-height: 40px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space:nowrap; 
  background: red;
  /* z-index: 2; */
}
.headers_box_img>img{
  width: 150px;
  /* height: 60px; */
}
.footer_bg{
  width: 100%;
  height: auto;
  background: white;
  margin-top: 100px;
  
  /* margin-top: 30px; */
  position: fixed;
  z-index: 1;
  /* left: 0; */
  /* top: 0;; */
  bottom: 0;
  /* right: 0; */
}
.footer_img{
    height: 60px;
  }
  .beian{
    width: 100%;
    line-height: 40px;
    /* background: white; */
    font-size: 10px;
  }

</style>
